import { createReducer } from "@reduxjs/toolkit";
import {
  educationalAdvisorSubmitTrainingItemEvaluation,
  resetEducationalAdvisorSubmitTrainingItemEvaluation,
} from "./submit-training-item-evaluation";
import type { ProcessingState } from "@redux/state/shared-types";

const initialState: ProcessingState = { processing: "idle" };

export const educationalAdvisorSubmitTrainingItemEvaluationReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(educationalAdvisorSubmitTrainingItemEvaluation.fulfilled, state => {
    return {
      ...state,
      processing: "success",
    };
  });
  builder.addCase(educationalAdvisorSubmitTrainingItemEvaluation.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(educationalAdvisorSubmitTrainingItemEvaluation.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetEducationalAdvisorSubmitTrainingItemEvaluation, () => {
    return initialState;
  });
});
